module.exports = __webpack_public_path__ + "static/media/pos-banner.0e926db2.png";